<template>
  <v-app
    id="login"
    class="primary"
  >
    <v-content>
      <v-container
        fluid
        fill-height
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex
            xs12
            sm8
            md8
            lg4
          >
            <v-stepper v-model="e1">
              <v-stepper-header>
                <v-stepper-step
                  :complete="e1 > 1"
                  step="1"
                >
                  Name of step 1
                </v-stepper-step>

                <v-divider />

                <v-stepper-step
                  :complete="e1 > 2"
                  step="2"
                >
                  Name of step 2
                </v-stepper-step>

                <v-divider />

                <v-stepper-step step="3">
                  Name of step 3
                </v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-card class="mb-5">
                    <v-flex
                      xs12
                      sm6
                    >
                      <v-text-field
                        label="Outline"
                        single-line
                        outline
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                    >
                      <v-text-field
                        label="Outline"
                        single-line
                        outline
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                    >
                      <v-text-field
                        label="Outline"
                        single-line
                        outline
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                    >
                      <v-text-field
                        label="Outline"
                        single-line
                        outline
                      />
                    </v-flex>
                  </v-card>

                  <v-btn
                    color="primary"
                    @click="e1 = 2"
                  >
                    {{ $t('Continue') }}
                  </v-btn>

                  <v-btn flat>
                    {{ $t('Cancel') }}
                  </v-btn>
                </v-stepper-content>

                <v-stepper-content step="2">
                  <v-card
                    class="mb-5"
                    color="grey lighten-1"
                    height="200px"
                  />

                  <v-btn
                    color="primary"
                    @click="e1 = 3"
                  >
                    {{ $t('Continue') }}
                  </v-btn>

                  <v-btn flat>
                    {{ $t('Cancel') }}
                  </v-btn>
                </v-stepper-content>

                <v-stepper-content step="3">
                  <v-card
                    class="mb-5"
                    color="grey lighten-1"
                    height="200px"
                  />

                  <v-btn
                    color="primary"
                    @click="e1 = 1"
                  >
                    {{ $t('Continue') }}
                  </v-btn>

                  <v-btn flat>
                    {{ $t('Cancel') }}
                  </v-btn>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      e1: 0
    }
  },
  methods: {}
}
</script>
